<template>
  <div class="overflow-y-scroll">
    <!--    <h3>Consultant</h3>-->
    <div class="map-tech-info flex items-center justify-center">
      <div class="flex-1">
        <h3>{{ (name ? name : email) | getNameByEmail }}</h3>
        <div>
          <span
            class="status-pill"
            :class="{ red: isActive != 'true', green: isActive == 'true' }"
          ></span>
          <span>{{ isActive == "true" ? "Active" : "Inactive" }}</span>
        </div>
        <p>{{ techLevel }}</p>
      </div>
      <div class="map-tech-info-avatar">
        <div class="map-tech-info-avatar-container">
          <span v-if="!photo">{{
            (name ? name : email) | getFirstLetter
          }}</span>
          <img v-else :src="photo" alt />
        </div>
      </div>
    </div>
    <section class="map-info">
      <div class="form-inline">
        <label>Email:</label>
        <div>{{ email ? email : "none" }}</div>
      </div>
      <div class="form-inline">
        <label>phonNumber:</label>
        <div>{{ phonNumber ? phonNumber : "none" }}</div>
      </div>
      <div class="form-inline">
        <label>Address:</label>
        <div>{{ address ? address : "none" }}</div>
      </div>
      <div class="form-inline">
        <label>Metro:</label>
        <div>{{ metro ? metro : "none" }}</div>
      </div>
      <div class="form-inline">
        <label>Rate:</label>
        <div>{{ rate ? rate : 0 | currencyFilter("$", 2) }}</div>
      </div>
      <div class="form-inline">
        <label>Bio:</label>
        <div>{{ bio ? bio : "none" }}</div>
      </div>
      <div class="form-inline">
        <button class="submit primary" @click="toConsultantDashboard">
          Consultant Dashboard
        </button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: [
    "name",
    "email",
    "isActive",
    "phonNumber",
    "address",
    "metro",
    "rate",
    "bio",
    "photo",
    "id",
    "techLevel",
  ],
  methods: {
    toConsultantDashboard: function () {
      this.$router.push({
        path: "/home/consultant/consultant_dashboard",
        query: { id: this.id },
      });
    },
  },
};
</script>
